import { SkeletonBlock } from '@/components/common/skeleton';

import styles from './notification-row-skeleton.module.scss';

export type NotificationRowSkeletonProps = {
  count?: number;
};

/**
 * Loading placeholder that mirrors a real notification row: a circular avatar,
 * a title line and a body line, plus a short timestamp block.
 */
export function NotificationRowSkeleton({ count = 5 }: NotificationRowSkeletonProps) {
  return (
    <div className={styles.list} aria-busy="true" aria-label="Loading">
      {Array.from({ length: count }, (_, i) => (
        <div key={i} className={styles.row} data-testid="notification-row-skeleton">
          <SkeletonBlock circle width={35} height={35} />
          <div className={styles.content}>
            <SkeletonBlock height={14} width="60%" />
            <SkeletonBlock height={12} width="85%" />
          </div>
          <SkeletonBlock height={12} width={32} />
        </div>
      ))}
    </div>
  );
}
